module.exports = ".row:nth-child(odd){\r\n    background: #ececec;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/roles/roles-form/roles-form.component.css
// module id = ./src/app/ultilities/roles/roles-form/roles-form.component.css
// module chunks = main